import React, { useState } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { debora, timelineDesk, timelineMobile, wellington } from "../../assets";
import Button from "../../shared/buttons";
import Heading from "../../shared/headings";
import Paragraph from "../../shared/paragraphs";
import FormWantBeVoluntary from "./formWantbeVoluntary";
import {
  AboutTag,
  ButtonContainer,
  CitiesPart,
  Founders,
  InfoPart,
  MapPart,
  MoreInfoPart,
  Spacer,
  TimeLineContainer,
} from "./styles";

function About() {
  const [open, setOpen] = useState(false);
  const [timeLineImage, setTimeLineImage] = useState(
    window.innerWidth <= 768 ? timelineMobile : timelineDesk
  );

  window.addEventListener("resize", () => {
    window.innerWidth <= 768
      ? setTimeLineImage(timelineMobile)
      : setTimeLineImage(timelineDesk);
  });

  return (
    <>
      <FormWantBeVoluntary open={open} setOpen={setOpen} />
      <AboutTag>
        <Founders>
          <Heading text={"Fundadores"} color={"#000000"} size={"h1"} />

          <ul>
            <li>
              <Heading color="#000000" text={"Débora Baptista"} size={"h2"} />
              <img src={debora} alt="" />
              <Paragraph text={"Presidente"} color={"#000000"} type={"P2"} />
            </li>

            <li>
              <Heading
                color="#000000"
                text={"Wellington Barroso"}
                size={"h2"}
              />
              <img src={wellington} alt="" />
              <Paragraph
                text={"Vice-presidente"}
                color={"#000000"}
                type={"P2"}
              />
            </li>
          </ul>

          <Paragraph text={"Observação: "} color={"#000000"} type={"P"} />
          <Paragraph
            text={
              "o Circuito Inclusão conta, ainda, com um fluxo de voluntários que atuam nos eventos promovidos e no polo esportivo e cultural."
            }
            color={"#000000"}
            type={"P"}
          />

          <ButtonContainer>
            <Button
              text={"Quero ser voluntário"}
              typeButton={"primary"}
              size={"medium"}
              func={() => setOpen(true)}
            />
          </ButtonContainer>
        </Founders>

        <TimeLineContainer>
          <Heading text={"Linha do tempo"} color={"#000000"} size={"h1"} />
          <Spacer size={32} />
          <Heading
            text={"Conheça os momentos marcantes da nossa história."}
            color={"#000000"}
            size={"h2"}
          />

          <img src={timeLineImage} alt="Timeline circuito history" />
        </TimeLineContainer>

        <InfoPart>
          <Heading text={"Missão"} color={"#000000"} size={"h1"} />
          <Paragraph
            text={
              "Ampliar o acesso da pessoa com deficiência ao esporte como lazer e saúde. "
            }
            color={"#000000"}
            type={"P"}
          />
        </InfoPart>

        <InfoPart>
          <Heading text={"Visão"} color={"#000000"} size={"h1"} />
          <Paragraph
            text={
              "SER REFERÊNCIA EM INCLUSÃO E PARTICIPAÇÃO SOCIAL PARA AS PESSOAS COM DEFICIÊNCIA E SUAS FAMÍLIAS."
            }
            color={"#000000"}
            type={"P"}
          />
        </InfoPart>

        <InfoPart>
          <Heading text={"Valores"} color={"#000000"} size={"h1"} />
          <Paragraph
            text={
              "VALORIZAÇÃO DO SER HUMANO E DO BRINCAR; ÉTICA E TRABALHO EM EQUIPE; RESPEITO À VIDA E À DIVERSIDADE; INTEGRIDADE, TRANSPARÊNCIA E INCLUSÃO SOCIAL."
            }
            color={"#000000"}
            type={"P"}
          />
        </InfoPart>

        <MoreInfoPart>
          <Heading text={"Onde estamos"} />
          <div>
            <CitiesPart>
              <Paragraph
                type={"P"}
                text={`Nossa sede fica situada na cidade de Contagem em 
                  Minas Gerais, mas já realizamos eventos em diversas 
                  cidades do Brasil e em outros países.`}
              />
              <ul>
                <li>
                  <Paragraph text={"Belo Horizonte/MG"} type={"P"} />
                </li>
                <li>
                  <Paragraph text={" Betim/MG "} type={"P"} />
                </li>
                <li>
                  <Paragraph text={" Cabo Frio/RJ"} type={"P"} />
                </li>
                <li>
                  <Paragraph text={"Igarapé/MG"} type={"P"} />
                </li>
                <li>
                  <Paragraph text={"Juatuba/MG"} type={"P"} />
                </li>
                <li>
                  <Paragraph
                    text={"Justinópolis (distrito de Ribeirão das Neves)/MG"}
                    type={"P"}
                  />{" "}
                </li>
                <li>
                  <Paragraph text={"Mateus Leme/MG"} type={"P"} />
                </li>
                <li>
                  <Paragraph text={"Ribeirão das Neves/MG"} type={"P"} />
                </li>
                <li>
                  <Paragraph text={"Sabará/MG"} type={"P"} />
                </li>
                <li>
                  <Paragraph text={"Timóteo/MG"} type={"P"} />
                </li>
                <li>
                  <Paragraph text={"Vespasiano/MG"} type={"P"} />
                </li>
                <Spacer size={"38"} />
                <li>
                  <Paragraph
                    text={` São Paulo, Campinas, Curitiba, Manaus/Amazonas, Rio Grande do
                Sul (online)`}
                    type={"P"}
                  />
                </li>
                <li>
                  <Paragraph text={"Egito (online)"} type={"P"} />
                </li>
              </ul>
            </CitiesPart>
            <MapPart>
              <FaMapMarkerAlt size={200} color={"#1485C7"} />
              <Heading text={"Contagem/MG"} />
            </MapPart>
          </div>
        </MoreInfoPart>
      </AboutTag>
    </>
  );
}

export default About;
